import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
    TgBoxes2Module,
    TgButtons2Module,
    TgGridModule,
    TgInputModule,
    TgSelectModule,
    TgRackModule,
    TgRadioModule,
    TgLists2Module,
    TgInfoBoxModule,
    TgCardModule,
    TgCheckboxModule
} from '@trademe/tangram';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule } from '@angular/forms';
import { PropertyAgentPromoteSectionComponent } from './property-agent-promote-section.component';
import { DraftValidationModule, TrademeCoreUiPipeModule } from '@classifieds-sell/shared';

@NgModule({
    imports: [
        CommonModule,
        DraftValidationModule,
        FormsModule,
        LayoutModule,
        RouterModule,
        TgBoxes2Module,
        TgButtons2Module,
        TgCardModule,
        TgGridModule,
        TgInputModule,
        TgLists2Module,
        TgInfoBoxModule,
        TgRackModule,
        TgRadioModule,
        TgSelectModule,
        TgCheckboxModule,
        TrademeCoreUiPipeModule
    ],
    declarations: [PropertyAgentPromoteSectionComponent],
    exports: [PropertyAgentPromoteSectionComponent]
})
export class PropertyAgentPromoteSectionModule {}
